<template>
  <server-table
    ref="table"
    :api-request="apiRequest"
    :busy.sync="table.loading"
    :columns="table.columns"
    :no-border-collapse="false"
    :sort-by.sync="table.sortBy"
    sort-desc
    responsive
    striped
    table-class="table-sm"
    @refreshed="onRefreshed"
  >
    <div slot="beforeSearch" class="flex-grow-1">
      <h4 class="m-0">
        Meradlá <small>({{ count }})</small>
      </h4>
    </div>
    <template #afterSearch>
      <b-btn
        v-show="false"
        v-b-tooltip.hover.bottom
        class="ml-2"
        variant="outline-secondary"
        title="Exportovať"
        @click="exportDevices"
      >
        <b-icon icon="arrow-down-short" class="mr-n1" />
        <b-icon icon="file-earmark-spreadsheet" />
      </b-btn>
    </template>
    <template #cell(actions)="data">
      <b-dropdown class="btn-p-0" no-caret variant="link">
        <template slot="button-content">
          <b-icon icon="text-indent-left" scale="1.25x" />
        </template>
        <b-dropdown-item @click.prevent="edit(data.item.id)">
          <b-icon class="mr-1" icon="pencil-square" />
          Upraviť
        </b-dropdown-item>
        <b-dropdown-item
          @click="
            $root.$emit('operation.view', { name: 'history', data: data.item })
          "
        >
          <b-icon class="mr-1" icon="clock-history" />
          História
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <template #cell(name)="data">
      {{ data.value }}
      <b-badge v-if="!data.item.isActive" variant="danger" class="align-middle">
        NEAKTÍVNE
      </b-badge>
    </template>
  </server-table>
</template>
<script>
import ServerTable from '@/components/ServerTable'
import operationService from '@/services/api/operationService'

export default {
  components: {
    ServerTable,
  },
  data() {
    return {
      count: null,
      table: {
        loading: false,
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'name',
            label: 'Názov',
            tdClass: 'name-width',
            sortable: true,
          },
          {
            key: 'serialNumber',
            label: 'Sériové číslo',
            tdClass: 'name-width',
            sortable: true,
          },
          {
            key: 'section',
            label: 'Sekcia',
          },
          {
            key: 'floor',
            label: 'Podlažie',
          },
          {
            key: 'note',
            label: 'Poznámka',
          },
        ],
      },
    }
  },
  mounted() {
    this.$root.$on('operation.reloadDeviceData', this.$refs.table.refresh)
  },
  beforeDestroy() {
    this.$root.$off('operation.reloadDeviceData')
  },
  methods: {
    onRefreshed() {
      this.count = this.$refs.table.totalRows
    },
    apiRequest(params) {
      let quickSearch = {}
      if (params.query) {
        quickSearch = {
          'quickSearch[items]': 'name|serialNumber|note|section',
          'quickSearch[term]': params.query,
        }
      }
      return operationService
        .findDevicesByDeliveryPointId(
          this.$store.getters['operation/get'].callback_id,
          {
            orderBy: params.orderBy,
            maxResults: params.maxResults,
            startAt: params.startAt,
            ...this.table.filter,
            ...quickSearch,
          },
        )
        .then((res) => {
          res.data = {
            filtered: params.maxResults,
            total: res.headers['x-pagination-total-count']
              ? res.headers['x-pagination-total-count']
              : 0,
            rows: res.data,
          }
          return res
        })
    },
    edit(id) {
      this.$root.$emit('operation.openMeasurerModal', { id: id })
    },
    exportDevices() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
    },
  },
}
</script>
